export const PAYROLL_PERIOD_PERMISSION_CODES = {
    WEB_PAYROLL_PERIOD_LIST: 'WEB_PAYROLL_PERIOD_LIST',
    WEB_PAYROLL_PERIOD_DETAIL: 'WEB_PAYROLL_PERIOD_DETAIL',
    WEB_PAYROLL_PERIOD_ADD: 'WEB_PAYROLL_PERIOD_ADD',
    WEB_PAYROLL_PERIOD_EDIT: 'WEB_PAYROLL_PERIOD_EDIT',
    WEB_PAYROLL_PERIOD_DELETE: 'WEB_PAYROLL_PERIOD_DELETE',
    WEB_PAYROLL_PERIOD_IMPORT: 'WEB_PAYROLL_PERIOD_IMPORT',
    WEB_PAYROLL_PERIOD_EXPORT: 'WEB_PAYROLL_PERIOD_EXPORT',
} as const;


